import * as React from 'react';

export function IconAffirm(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 51 20" fill="none" {...props}>
      <title>Affirm</title>
      <g
        clipPath="url(#prefix__clip0_17_11)"
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <path
          d="M4.108 11.27c-1.354 0-2.922.646-3.773 1.317l.779 1.629c.682-.623 1.784-1.15 2.778-1.15.946 0 1.461.311 1.461.946 0 .431-.347.647-.994.73C1.916 15.054 0 15.726 0 17.605 0 19.09 1.066 20 2.719 20c1.185 0 2.24-.659 2.742-1.521v1.282h2.204v-5.378c0-2.215-1.545-3.113-3.557-3.113zm-.827 7.006c-.622 0-.934-.3-.934-.803 0-.934 1.042-1.245 2.946-1.449.012 1.245-.838 2.252-2.012 2.252zm25.162-5.378V11.51H26.24v8.252h2.36v-3.977c0-1.892 1.137-2.443 1.94-2.443.311 0 .73.096 1.006.3l.431-2.18c-.36-.156-.742-.191-1.054-.191-1.21 0-1.976.538-2.479 1.628zm14.48-1.628c-1.246 0-2.18.742-2.672 1.449-.455-.923-1.4-1.45-2.55-1.45-1.246 0-2.108.695-2.515 1.486v-1.246H32.91v8.252h2.36v-4.252c0-1.521.802-2.252 1.544-2.252.671 0 1.294.432 1.294 1.557v4.947h2.371v-4.252c0-1.545.779-2.252 1.557-2.252.623 0 1.281.456 1.281 1.545v4.959h2.36V14.06c0-1.856-1.246-2.79-2.755-2.79zM16 10.898v.611h-3.58v-.838c0-1.09.622-1.402 1.16-1.402.312 0 .72.072 1.055.264l.73-1.665c-.43-.251-1.138-.479-2.084-.479-1.508 0-3.221.85-3.221 3.521v.611H8.695v1.82h1.365v6.42h2.36v-6.432H16v6.431h2.36v-6.43h2.143v-1.821h-2.144v-.838c0-1.09.623-1.402 1.162-1.402a2.31 2.31 0 011.054.264l.73-1.665s-.742-.479-2.083-.479C17.725 7.377 16 8.228 16 10.9zm5.904.611h2.36v8.252h-2.36v-8.252z"
          fill="#060809"
        />
        <path
          d="M35.653 0C29.28 0 23.605 4.42 22 10.108h2.311c1.342-4.24 5.905-7.952 11.342-7.952 6.61 0 12.311 5.03 12.311 12.862 0 1.76-.227 3.341-.659 4.742h2.24l.024-.071c.371-1.45.55-3.018.55-4.671C50.12 6.288 43.762 0 35.654 0z"
          fill="#0FA0EA"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_17_11">
          <path fill="#fff" d="M0 0h50.299v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
